import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

import './style.css';

/**
 * Props:
 * waitingSearch: boolean value that specifies if we should display a spinning icon or not.
 * onChange: function to be called when the search terms change.
 * placeholder: input placeholder
 */
export default class LiveSearch extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    waitingSearch: PropTypes.bool,
    placeholder: PropTypes.string
  };

  constructor() {
    super();

    this.onSearchChange = this.onSearchChange.bind(this);
    this.fireSearchChange = this.fireSearchChange.bind(this);
    this.clearSearch = this.clearSearch.bind(this);

    this.state = {
      search: '',
      timer: null,
      lastFiredSearch: ''
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.value !== this.props.value && newProps.value !== this.state.search) {
      this.fireSearchChange(newProps.value);
    }
  }

  fireSearchChange(searchValue) {
    if (searchValue === undefined)
      searchValue = this.state.search;

    if (searchValue.trim() !== this.state.lastFiredSearch) {
      if (this.props.onChange) {
        this.props.onChange(searchValue);
      }
      this.setState({
        search: searchValue,
        lastFiredSearch: searchValue,
        timer: null
      });
    } else if (searchValue !== this.state.search) {
      this.setState({
        search: searchValue,
      });
    }
  }

  onSearchChange(event) {
    // TODO: make this 500 a prop.
    if (this.state.timer)
      clearTimeout(this.state.timer);

    let searchValue = event.target.value;
    let timer = setTimeout(this.fireSearchChange, 500);

    this.setState({
      search: searchValue,
      timer: timer
    });

    if (!timer)
      this.fireSearchChange(searchValue);
  }

  clearSearch() {
    if (this.state.timer)
      clearTimeout(this.state.timer);

    this.fireSearchChange('');
  }

  render() {
    let statusIcon;
    if (this.props.waitingSearch) {
      statusIcon = <i className="fa fa-refresh" aria-hidden="true"/>;
    }

    return(
      <div className="live-search">
        <span className="input-box">
          <span className="input-element">
            <input type="text" id={this.props.id || 'live-search'} onChange={this.onSearchChange} value={this.state.search} placeholder={this.props.placeholder} />
          </span>
          <span className="status-icon">{statusIcon}</span>
        </span>
        <span>{this.props.children}</span>
        <span className="actions"><Button onClick={this.clearSearch}>Clear</Button></span>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/LiveSearch/index.js
 **/